module.exports = __webpack_public_path__ + "img/bimboot1.0ef2738e.png";